module.exports = __webpack_public_path__ + "assets/img/share.f3d0fbec.png";